import { render, staticRenderFns } from "./GardenRewardsCentreData.vue?vue&type=template&id=e629f324&scoped=true"
import script from "./GardenRewardsCentreData.vue?vue&type=script&lang=js"
export * from "./GardenRewardsCentreData.vue?vue&type=script&lang=js"
import style0 from "./GardenRewardsCentreData.vue?vue&type=style&index=0&id=e629f324&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e629f324",
  null
  
)

export default component.exports